/**
 * Power distribution list column width tokens — equal flex per rack table design (#1154).
 */

import {
  repeatableColumnCellStyle,
  repeatableColumnHorizontalPadding,
  repeatableCompactColumnLayoutForTests,
  repeatableDesktopColumnLayoutForTests,
} from '../repeatableSections/repeatableTableColumnLayout';

import type {
  PowerDistributionTableColumnKey,
  PowerDistributionTableLayout,
} from './powerDistributionListUtils';

export function powerDistributionColumnHorizontalPadding(
  column: PowerDistributionTableColumnKey,
  layoutMode: PowerDistributionTableLayout,
): number {
  return repeatableColumnHorizontalPadding(column, layoutMode);
}

export function powerDistributionColumnCellStyle(
  column: PowerDistributionTableColumnKey,
  layoutMode: PowerDistributionTableLayout,
): Record<string, unknown> {
  const paddingHorizontal = powerDistributionColumnHorizontalPadding(
    column,
    layoutMode,
  );
  // Desktop: keep STATUS compact. Compact/mobile: equal flex with other columns.
  if (column === 'STATUS' && layoutMode !== 'compact') {
    return {
      flex: 0,
      flexGrow: 0,
      flexShrink: 0,
      width: 84,
      minWidth: 84,
      paddingHorizontal,
    };
  }
  return repeatableColumnCellStyle(column, layoutMode);
}

/** @internal — unit tests assert equal flex layout. */
export const desktopColumnLayoutForTests =
  repeatableDesktopColumnLayoutForTests;

/** @internal — unit tests assert equal flex layout. */
export const compactColumnLayoutForTests =
  repeatableCompactColumnLayoutForTests;
